import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "./ProductsSwiper.css";
import Product1 from '../images/product1.jpeg';
import Product2 from '../images/product2.jpeg';
import Product3 from '../images/product3.jpeg';
import Product4 from '../images/product4.jpeg';
import Product5 from '../images/product5.jpeg';
import Product6 from '../images/product6.jpeg';
import Product7 from '../images/product7.jpeg';
import Product8 from '../images/product8.jpeg';
import Product9 from '../images/product9.jpeg';



import Product from './Product';
SwiperCore.use([Navigation, Pagination, Autoplay]);
const ProductsSwiper = () => {
    const customPrevButton = (
        <IoIosArrowBack size={30} color="#333" className="swiper-button-prev" />
    );

    const customNextButton = (
        <IoIosArrowForward size={30} color="#333" className="swiper-button-next" />
    );

    return (
        <div className='py-4 my-8 mb-16 rounded-2xl'>
            <div>
                <div data-aos="fade-zoom-in" data-aos-easing="linear" className=' mt-16 text-3xl font-bold text-center text-main'>רכישת מוצרים</div>
                <div data-aos="fade-zoom-in" data-aos-easing="linear" className="h-[1px] w-[260px] mx-auto mt-4 bg-main"></div>
                <p className='text-xs text-center text-black mt-4'>משלוח חינם עד בית הלקוח בקנייה מעל 350 ש"ח</p>

            </div>
            <Swiper
                navigation={{
                    prevEl: ".swiper-button-prev",
                    nextEl: ".swiper-button-next",
                }}
                pagination={{ clickable: true }}
                loop
                speed={1000}
                autoplay={{ delay: 500 }}
                className="swiper3 my-4"
            >
                <SwiperSlide>
                    <Product
                        headline="ליפ איט – LIP IT"
                        info="פרופסי שפתיים חומצה היאלורונית החדרת חומצה היאלורונית לשפתיים ללא הזרקה, לחות לשפתיים, טיפוח שפתיים, קרם לעיבוי שפתיים."
                        image={Product1}
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <Product
                        headline="PROPHECY EYE – פרופסי עיניים חוה זינגבוים חומצה היאלורונית
                        "
                        info="מטשטש כהות מתחת לעיניים.
                        מטשטש סימני עייפות באזור העיניים.
                        עוזר לטשטש קמטי חיוך והבעה.
                        מסייע בטשטוש שקעים ועור יבש.
                        מותח את העור מסביב לעיניים.
                        מוסיף לחות לעור.
                        מקל על הנפיחויות בעיניים.
                        מכיל קפאין ומסייע בזרימת הדם."
                        image={Product2}
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <Product
                        headline="סבון ירוק "
                        info="סבון לניקוי העור, הניקוי עדין ושומר על לחות העור מבלי לייבש אותו, מחזק את שכבת ההגנה הטבעית של העור, מסיר ומחדש תאים.

                        הסבון מכיל רכיבים אנטי בקטריאליים (נגד חיידקים) אנטיספטים (תורמים לחיטוי)  ואנטיויראליים וכן חומרים מרגיעים.
                        
                        מאפשר הכנה טובה לקראת החדרת קרם.
                        
                        מתאים לכל סוגי העור"
                        image={Product3}
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <Product
                        headline="אנטי פולושן סרום "
                        info="LACTOBACILLUS – לאיזון פלורת החיידקים
                        HYALURONIC ACID – אנטי אוקסידנט
                        CHICORY ROOT EXTRACT – לייצור טבעי של ויטמין D
                        PSEUDOALTEROMONAS – למניעת נזקי קרינה כחולה
                        BETAINE – להרגעת העור וללחות"
                        image={Product4}
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <Product
                        headline="מסכת פיוריפיינג Purifying Mask
                        "
                        info="🍃מטהרת את העור
                        🍃מאזנת את רמת שומניות העור
                        🍃מורידה ייצור שומנים תת עוריים (מיליומים)
                        🍃מאיצה תהליכי ריפוי לאורך זמן"
                        image={Product5}
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <Product
                        headline="SILKY FILTER 
                        "
                        info="קרם הגנה בשילוב עם פריימר בטכנולוגיה מתקדמת עם  50SPF, המספק הגנה מפני קרני השמש והגנה אנטי אוקסידנטית עוצמתית. מתאים במיוחד לשימוש כבסיס לאיפור, אך גם ללא איפור."
                        image={Product6}
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <Product
                        headline="PROPHECY
                        פרופסי 2
                        
                        "
                        info="פותח עולם שלם של אפשרויות
                        הקרם מציע אופציה נוספת להחדרת חומצה היאלורונית לעור.
                        הוא מטפל בכל מרקם העור על בסיס יומי, מה שהזרקה לא עושה.
                        ברוב המקרים נראה שיפור משמעותי ברמה ובעומק של קמטוטים ( התוצאות משתנות מאדם לאדם )"
                        image={Product7}
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <Product
                        headline="FOAMING CLEANSER
                        "
                        info="סבון פנים מקציף ומנקה, מתאים לכל סוגי העור, הסבון נעים ובעל מרקם קליל על פני העור."
                        image={Product8}
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <Product
                        headline="ערכת LOVE YOURSELF חוה זינגבוים VALENTINES DAY"
                        info="מהדורה מוגבלת: קרם עיניים + קרם פנים מסדרת הקולגן 
                        Remicronized מסדרת הקולגן הפברילי בשילוב חומצה היאלורונית אשר חודרים אל עומק העור וממצקים אותו בצורה יעילה ומוכחת מחקרית."
                        image={Product9}
                    />
                </SwiperSlide>





                <div className="swiper-button-prev-custom">{customPrevButton}</div>
                <div className="swiper-button-next-custom">{customNextButton}</div>
            </Swiper>
        </div>

    );
}

export default ProductsSwiper